module.exports = __webpack_public_path__ + "img/138-Gris Titanium Lisse SFTN.jpg";